import { Component } from "@angular/core";
import * as C from "../../../../../../shared/constants/globals.constants";
import { EWizDynamicBaseClassComponent } from "src/app/modules/esim/shared/classes/ewiz-dynamic.class";

@Component({
    selector: C.EWIZ_SELECT_AUTHENTICATION_ALGORITHM,
    templateUrl: "./select-authentication-algorithm.component.html",
    standalone: false
})
export class EWizSelectAuthenticationAlgorithmComponent extends EWizDynamicBaseClassComponent {}
